import { CartActions } from '@wix/wixstores-client-core/dist/es/src/cart-actions/cartActions';
import { PageMap } from '@wix/wixstores-client-core/dist/es/src/constants';
var ProductService = /** @class */ (function () {
    function ProductService(siteStore, pubSubManager) {
        this.siteStore = siteStore;
        this.cartActions = new CartActions(this.siteStore, pubSubManager, 'product-page', PageMap.CART);
    }
    ProductService.prototype.addToCart = function (product, navigate) {
        if (navigate === void 0) { navigate = false; }
        var customTextFields = undefined;
        var selectionIds = undefined;
        var quantity = 1;
        if (navigate) {
            return this.siteStore.navigate({
                sectionId: PageMap.PRODUCT,
                state: product.urlPart,
                queryParams: undefined,
            }, true);
        }
        return this.cartActions.addToCart(product.id, selectionIds, quantity, customTextFields, true);
    };
    return ProductService;
}());
export { ProductService };
//# sourceMappingURL=ProductService.js.map